var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxsMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 13.766,
    viewBox: "0 0 15 13.766",
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17 5.173-9.5 3.392v5.25l.561.2-.846 1.691a1.5 1.5 0 0 0 .868 2.094l3.063 1.021a1.511 1.511 0 0 0 1.816-.752l.977-1.955 3.061 1.093a.75.75 0 0 0 1-.707v-10.621a.75.75 0 0 0 -1-.706zm-5.38 12.227-3.063-1.023.927-1.853 3.031 1.083-.9 1.791zm-7.12-3.585h1.5v-5.25h-1.5a1.5 1.5 0 0 0 -1.5 1.5v2.25a1.5 1.5 0 0 0 1.5 1.5z",
    fill: "#3c2f87",
    transform: "translate(-3 -5.13)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsMegaphone);
export default __webpack_public_path__ + "static/media/bxs-megaphone.e2cf56178a97723d8d46d7687e016646.svg";
export { ForwardRef as ReactComponent };